<template>
    <div class="guidemask" v-if="maskshow">
        <div class="stepbox">
            <div id="cloudy" class="cloudy scale" :style="{left:cloudL,top:cloudT}"></div>
            <div class="guide" :class="[currentStep === 1 ? 'gShow' : '']">
                <img v-if="$root.$lang === 'zh-CN'" class="g1" src="@/assets/image/home/guide1.png" alt="img1">
                <img v-else class="g1" src="@/assets/image/home/guide1-en.png" alt="img1">
                <img class="ga1" src="@/assets/image/home/guide_arrow1.png" alt="img1-1">
                <div class="contain step1">
                    <span class="posab el-icon-close" @click="closeMask(1)"></span>
                    <div class="bgcontain" :style="{visibility:currentStep === 1?'visible':'hidden'}">
                        <span>{{ $t("guidemask.step1") }}</span>
                    </div>
                    <div class="btncontain">
                        <span @click="nextStep(2)">{{ $t("guidemask.next") }}</span>
                    </div>
                </div>
            </div>
            <div class="guide" :class="[currentStep === 2 ? 'gShow' : '']">
                <img class="g2" src="@/assets/image/home/guide2.png" alt="img2">
                <img class="ga2" src="@/assets/image/home/guide_arrow1.png" alt="img2-2">
                <div class="contain step2">
                    <span class="posab el-icon-close" @click="closeMask(2)"></span>
                    <div class="bgcontain" :style="{visibility:currentStep === 2?'visible':'hidden'}">
                        <span>{{ $t("guidemask.step2") }}</span>
                    </div>
                    <div class="btncontain">
                        <span @click="prevStep(1)">{{ $t("guidemask.back") }}</span>
                        <span @click="nextStep(3)">{{ $t("guidemask.next") }}</span>
                    </div>
                </div>
            </div>
            <div class="guide" :class="[currentStep === 3 ? 'gShow' : '']">
                <img class="g3" src="@/assets/image/home/guide3.png" alt="img3">
                <img class="ga3" src="@/assets/image/home/guide_arrow2.png" alt="img3-3">
                <div class="contain step3">
                    <span class="posab el-icon-close" @click="closeMask(3)"></span>
                    <div class="bgcontain" :style="{visibility:currentStep === 3?'visible':'hidden'}">
                        <span>{{ $t("guidemask.step3") }}</span>
                    </div>
                    <div class="btncontain">
                        <span @click="prevStep(2)">{{ $t("guidemask.back") }}</span>
                        <span @click="nextStep(4)">{{ $t("guidemask.next") }}</span>
                    </div>
                </div>
            </div>
            <div class="guide" :class="[currentStep === 4 ? 'gShow' : '']">
                <img class="g4" v-if="$root.$lang === 'zh-CN'" src="@/assets/image/home/guide4.png" alt="img4">
                <img class="g4" v-else src="@/assets/image/home/guide4-en.png" alt="img4">
                <img class="ga4" src="@/assets/image/home/guide_arrow3.png" alt="img4-4">
                <div class="contain step4">
                    <div class="bgcontain" :style="{visibility:currentStep === 4?'visible':'hidden'}">
                        <span>{{ $t("guidemask.step4") }}</span>
                    </div>
                    <div class="btncontain">
                        <span @click="prevStep(3)">{{ $t("guidemask.back") }}</span>
                        <span @click="maskshow = false">{{ $t("guidemask.close") }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    name:'guidemask',
    data(){
        return{
            maskshow:false,
            cloudL:'260px',
            cloudT:'80px',
            currentStep:1,
        }
    },
    computed:{
        ...mapGetters('Home', [
            'guideShow'
        ])
    },
    methods:{
        nextStep(st){
            let space = Math.abs(this.currentStep - st)
            if(space != 1) return
            this.currentStep = st;
            if(st === 2){
                this.cloudL = '40px';
                this.cloudT = '260px';
            }
            if(st === 3){
                this.cloudL = '104px';
                this.cloudT = "calc(100% - 210px)";
            }
            if(st === 4){
                this.cloudL = 'calc(100% - 370px)';
                this.cloudT = '100px';
            }
        },
        prevStep(st){
            let space = Math.abs(this.currentStep - st)
            if(space != 1) return
            this.currentStep = st;
            if(st === 1){
                this.cloudL = '260px';
                this.cloudT = '80px';
            }
            if(st === 2){
                this.cloudL = '40px';
                this.cloudT = '260px';
            }
            if(st === 3){
                this.cloudL = '104px';
                this.cloudT = "calc(100% - 210px)";
            }
        },
        closeMask(st){
            let space = Math.abs(this.currentStep - st)
            if(space != 0) return
            this.maskshow = false;
        }
    },
    mounted(){
        this.maskshow = this.guideShow ? true : false;
    }
}
</script>

<style lang="less" scoped>
.guidemask{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    min-height: 100vh;
    z-index: 9999;
    background: rgba(0,0, 0, .8);
    user-select: none;
    .stepbox{
        width: 100%;
        height: 100vh;
        position: relative;
        .cloudy{
            position: absolute;
            width: 260px;
            height: 140px;
            background: url('../../assets/image/home/guide_bg.png') no-repeat;
            background-size: contain;
            transition: all .5s ease;
        }
        .guide{
            opacity: 0;
            transition: all .8s ease;
            .contain {
                z-index: 0;
                .posab{
                   z-index: 0;
                   cursor: initial;
                }
                .btncontain{
                    span{
                        cursor: initial;
                    }
                }
            }
        }
        .gShow{
            opacity: 1;
            .contain {
                z-index: 9;
                .posab{
                   z-index: 9;
                   cursor: pointer;
                }
                .btncontain{
                    span{
                        cursor: pointer;
                    }
                }
            }
        }
        .contain{
            position: absolute;
            width: 260px;
            height: 180px;
            color: #fff;
            font-weight: 300;
            .bgcontain{
                width: 100%;
                height: 140px;
                span{
                    display: inline-block;
                    margin-top: 50px;
                    margin-left: 30px;
                    width: 200px;
                    text-indent: 2em;
                    font-size: 14px;
                    letter-spacing: 2px;
                    line-height: 1.5em;
                }
            }
            .btncontain{
                width: 100%;
                height: 30px;
                text-align: center;
                margin-top: 5px;
                span{
                    display: inline-block;
                    padding: 3px 12px;
                    border: 1px solid #fff;
                    margin: 0 15px;
                    border-radius: 50px;
                }
            }
            .posab{
                position: absolute;
                right: 4px;
                top: 4px;
                border: 1px solid #fff;
                border-radius: 50%;
                padding: 3px;
            }
        }
        .step1{
            top: 80px;
            left: 260px;
        }
        .step2{
            top: 260px;
            left: 40px;
        }
        .step3{
            bottom: 30px;
            left: 104px;
        }
        .step4{
            top: 100px;
            right: 110px;
        }
        img{
            position: absolute;
            display: block;
        }
        .g1{
            width: 100px;
            left: 160px;
            top: 2px;
            box-shadow: 0px 0px 50px #888888;
        }
        .ga1{
            width: 100px;
            top: 20px;
            left: 270px;
        }
        .g2{
            width: 40px;
            top: 96px;
            left: 0;
            box-shadow: 0px 0px 50px #888888;
        }
        .ga2{
            width: 100px;
            top: 200px;
            left: 50px;
        }
        .g3{
            width: 40px;
            bottom: 10px;
            left: 0;
            box-shadow: 0px 0px 50px #888888;
        }
        .ga3{
            width: 90px;
            bottom: 55px;
            left: 10px;
        }
        .g4{
            width: 132px;
            top: 0px;
            right: 10px;
            box-shadow: 0px 0px 50px #888888;
        }
        .ga4{
            width: 80px;
            top: 50px;
            right: 60px;
        }
    }
}
.scale{
    animation: scaleDraw 5s infinite;
}
@keyframes scaleDraw{
    0%{
        transform: scale(1);
    }
    25%{
        transform: scale(1.08);
    }
    50%{
        transform: scale(1);
    }
    75%{
        transform: scale(1.08);
    }
}
</style>